import { FC } from 'react';

interface ImageUrlConverterProps {
  url: string;
}

/**
 * Komponent pomocniczy do konwersji starych statycznych URL-i obrazów
 * na nowe dynamiczne API endpoint-y
 */
export const convertImageUrl = (url: string): string => {
  // Jeśli URL już wskazuje na API endpoint, zwróć bez zmian
  if (url.startsWith('/api/uploads/')) {
    return url;
  }
  
  // Jeśli URL wskazuje na statyczny folder uploads, przekonwertuj na API endpoint
  if (url.startsWith('/uploads/')) {
    return url.replace('/uploads/', '/api/uploads/');
  }
  
  // Dla zewnętrznych URL-i lub innych, zwróć bez zmian
  return url;
};

/**
 * Hook do konwersji URL-i obrazów
 */
export const useImageUrl = (url: string): string => {
  return convertImageUrl(url);
};

export default convertImageUrl;
